var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 85.35 92.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#886a6a;}.cls-3{isolation:isolate;}.cls-4{clip-path:url(#clip-path);}.cls-5{fill:#ffecec;}.cls-6{fill:#ffebeb;}.cls-7{fill:#ffeaea;}.cls-8{fill:#ffe9e9;}.cls-9{fill:#ffe8e8;}.cls-10{fill:#ffe7e7;}.cls-11{fill:#ffe6e6;}.cls-12{fill:#ffe5e5;}.cls-13{fill:#ffe4e4;}.cls-14{fill:#ffe3e3;}.cls-15{fill:#ffe2e2;}.cls-16{fill:#ffe1e1;}.cls-17{fill:#ffe0e0;}.cls-18{fill:#ffdede;}.cls-19{fill:#fdd;}.cls-20{fill:#ffdbdb;}.cls-21{fill:#ffd9d9;}.cls-22{fill:#ffd4d4;}.cls-23{fill:#ffd0d0;}.cls-24{fill:#fcc;}.cls-25{fill:#fdc7c7;}.cls-26{fill:#f8c3c3;}.cls-27{fill:#f3bfbf;}.cls-28{fill:#ecbbbb;}.cls-29{fill:#e7b6b6;}.cls-30{fill:#e2b2b2;}.cls-31{fill:#ddafaf;}.cls-32{fill:#d8abab;}.cls-33{fill:#d3a6a6;}.cls-34{fill:#cea1a1;}.cls-35{fill:#c89d9d;}.cls-36{fill:#c39999;}.cls-37{fill:#be9494;}.cls-38{fill:#b89090;}.cls-39{fill:#b28c8c;}.cls-40{fill:#ad8888;}.cls-41{fill:#a88383;}.cls-42{fill:#a28080;}.cls-43{fill:#9d7c7c;}.cls-44{fill:#987878;}.cls-45{clip-path:url(#clip-path-2);}.cls-46{fill:#8d6e6e;}.cls-47{fill:#937373;}.cls-48{clip-path:url(#clip-path-3);}.cls-49{fill:#0069a2;}.cls-50{fill:#005490;}.cls-51{fill:#0f7fc1;}.cls-52,.cls-53{opacity:0.63;}.cls-52{fill:url(#Degradado_sin_nombre_107);}.cls-54{fill:url(#Degradado_sin_nombre_65);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84,25.71l0,.23s0,0-.08,0l0-.23S84,25.7,84,25.71Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.75,25.9l0-.23h0a.3.3,0,0,1,.14,0l0,.23c-.06,0-.13,0-.14,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84,25.94h0a.24.24,0,0,1-.14,0s-.09,0-.08,0l0-.23s0,0,.09,0a.32.32,0,0,0,.14,0h0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_107",
    x1: -4432.3,
    y1: 3882.06,
    x2: -4341.38,
    y2: 3882.06,
    gradientTransform: "translate(-3856.34 -4319.67) rotate(-90.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#fff",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#fff",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#fff",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#fff",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_65",
    x1: 100.64,
    y1: 22.9,
    x2: 33.78,
    y2: 71.12,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Degradado_sin_nombre_107"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tobi"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.89,25.9c-.06,0-.13,0-.14,0s0,0,.08,0A.24.24,0,0,0,84,26s0,0-.08-.05"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "83.89 25.9 83.92 25.67 83.93 25.67 83.89 25.9 83.89 25.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "83.89 25.9 83.93 25.67 83.93 25.67 83.89 25.9 83.89 25.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "83.89 25.9 83.93 25.67 83.93 25.67 83.89 25.9 83.89 25.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "83.89 25.9 83.93 25.67 83.94 25.67 83.9 25.9 83.89 25.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "83.9 25.9 83.94 25.67 83.94 25.67 83.9 25.9 83.9 25.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "83.9 25.9 83.94 25.67 83.94 25.67 83.9 25.9 83.9 25.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "83.9 25.9 83.94 25.67 83.94 25.67 83.9 25.9 83.9 25.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "83.9 25.9 83.94 25.67 83.94 25.67 83.9 25.9 83.9 25.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "83.9 25.9 83.94 25.67 83.94 25.67 83.91 25.9 83.9 25.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "83.91 25.9 83.94 25.67 83.94 25.67 83.91 25.9 83.91 25.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-11",
    points: "83.91 25.9 83.94 25.67 83.94 25.67 83.91 25.9 83.91 25.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "83.91 25.9 83.94 25.67 83.95 25.68 83.91 25.9 83.91 25.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "83.91 25.9 83.95 25.68 83.95 25.68 83.91 25.9 83.91 25.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "83.91 25.9 83.95 25.68 83.95 25.68 83.91 25.9 83.91 25.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "83.91 25.9 83.95 25.68 83.95 25.68 83.91 25.9 83.91 25.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "83.91 25.9 83.95 25.68 83.95 25.68 83.92 25.91 83.91 25.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-16",
    points: "83.92 25.91 83.95 25.68 83.95 25.68 83.92 25.91 83.92 25.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-17",
    points: "83.92 25.91 83.95 25.68 83.96 25.68 83.92 25.91 83.92 25.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-18",
    points: "83.92 25.91 83.96 25.68 83.96 25.68 83.92 25.91 83.92 25.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-19",
    points: "83.92 25.91 83.96 25.68 83.96 25.68 83.92 25.91 83.92 25.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-20",
    points: "83.92 25.91 83.96 25.68 83.96 25.68 83.92 25.91 83.92 25.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-21",
    points: "83.92 25.91 83.96 25.68 83.96 25.68 83.93 25.91 83.92 25.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-22",
    points: "83.93 25.91 83.96 25.68 83.97 25.68 83.93 25.91 83.93 25.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-23",
    points: "83.93 25.91 83.97 25.68 83.97 25.68 83.93 25.91 83.93 25.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-24",
    points: "83.93 25.91 83.97 25.68 83.97 25.68 83.93 25.91 83.93 25.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-25",
    points: "83.93 25.91 83.97 25.68 83.97 25.68 83.94 25.91 83.93 25.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-26",
    points: "83.94 25.91 83.97 25.68 83.98 25.68 83.94 25.91 83.94 25.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-27",
    points: "83.94 25.91 83.98 25.68 83.98 25.69 83.94 25.91 83.94 25.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-28",
    points: "83.94 25.91 83.98 25.69 83.99 25.69 83.95 25.92 83.94 25.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-29",
    points: "83.95 25.92 83.99 25.69 83.99 25.69 83.95 25.92 83.95 25.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-30",
    points: "83.95 25.92 83.99 25.69 83.99 25.69 83.95 25.92 83.95 25.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-31",
    points: "83.95 25.92 83.99 25.69 84 25.69 83.96 25.92 83.95 25.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-32",
    points: "83.96 25.92 84 25.69 84 25.69 83.96 25.92 83.96 25.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-33",
    points: "83.96 25.92 84 25.69 84 25.7 83.96 25.92 83.96 25.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-34",
    points: "83.96 25.92 84 25.7 84 25.7 83.96 25.93 83.96 25.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-35",
    points: "83.96 25.93 84 25.7 84 25.7 83.97 25.93 83.96 25.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-36",
    points: "83.97 25.93 84 25.7 84.01 25.7 83.97 25.93 83.97 25.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-37",
    points: "83.97 25.93 84.01 25.7 84.01 25.7 83.97 25.93 83.97 25.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-38",
    points: "83.97 25.93 84.01 25.7 84.01 25.7 83.97 25.93 83.97 25.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-39",
    points: "83.97 25.93 84.01 25.7 84.01 25.7 83.97 25.93 83.97 25.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-40",
    points: "83.97 25.93 84.01 25.7 84.01 25.71 83.97 25.93 83.97 25.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-41",
    points: "83.97 25.93 84.01 25.71 84.01 25.71 83.97 25.94 83.97 25.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-42",
    points: "83.97 25.94 84.01 25.71 84.01 25.71 83.97 25.94 83.97 25.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-43",
    points: "83.97 25.94 84.01 25.71 84.01 25.71 83.97 25.94 83.97 25.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-44",
    points: "83.97 25.94 84.01 25.71 84.01 25.71 83.97 25.94 83.97 25.94"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M83.75,25.9l0-.23h0l0,.23h0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-47",
    points: "83.76 25.89 83.8 25.66 83.81 25.66 83.77 25.89 83.76 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-44",
    points: "83.77 25.89 83.81 25.66 83.81 25.66 83.77 25.89 83.77 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-43",
    points: "83.77 25.89 83.81 25.66 83.82 25.66 83.78 25.89 83.77 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-42",
    points: "83.78 25.89 83.82 25.66 83.82 25.66 83.78 25.89 83.78 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-41",
    points: "83.78 25.89 83.82 25.66 83.82 25.66 83.79 25.89 83.78 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-40",
    points: "83.79 25.89 83.82 25.66 83.83 25.66 83.79 25.89 83.79 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-39",
    points: "83.79 25.89 83.83 25.66 83.83 25.66 83.8 25.89 83.79 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-38",
    points: "83.8 25.89 83.83 25.66 83.84 25.66 83.8 25.89 83.8 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-37",
    points: "83.8 25.89 83.84 25.66 83.84 25.66 83.8 25.89 83.8 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-36",
    points: "83.8 25.89 83.84 25.66 83.84 25.66 83.81 25.89 83.8 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-35",
    points: "83.81 25.89 83.84 25.66 83.85 25.66 83.81 25.89 83.81 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-34",
    points: "83.81 25.89 83.85 25.66 83.85 25.66 83.82 25.89 83.81 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-33",
    points: "83.82 25.89 83.85 25.66 83.86 25.66 83.82 25.89 83.82 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-32",
    points: "83.82 25.89 83.86 25.66 83.86 25.66 83.82 25.89 83.82 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-31",
    points: "83.82 25.89 83.86 25.66 83.86 25.66 83.83 25.89 83.82 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-30",
    points: "83.83 25.89 83.86 25.66 83.87 25.66 83.83 25.89 83.83 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-29",
    points: "83.83 25.89 83.87 25.66 83.87 25.66 83.83 25.89 83.83 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-28",
    points: "83.83 25.89 83.87 25.66 83.87 25.66 83.84 25.89 83.83 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-27",
    points: "83.84 25.89 83.87 25.66 83.88 25.66 83.84 25.89 83.84 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-26",
    points: "83.84 25.89 83.88 25.66 83.88 25.66 83.84 25.89 83.84 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-25",
    points: "83.84 25.89 83.88 25.66 83.88 25.66 83.84 25.89 83.84 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-24",
    points: "83.84 25.89 83.88 25.66 83.88 25.66 83.84 25.89 83.84 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-23",
    points: "83.84 25.89 83.88 25.66 83.88 25.66 83.85 25.89 83.84 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-22",
    points: "83.85 25.89 83.88 25.66 83.89 25.66 83.85 25.89 83.85 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-21",
    points: "83.85 25.89 83.89 25.66 83.89 25.66 83.85 25.89 83.85 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-20",
    points: "83.85 25.89 83.89 25.66 83.89 25.66 83.85 25.89 83.85 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-19",
    points: "83.85 25.89 83.89 25.66 83.89 25.66 83.85 25.89 83.85 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-18",
    points: "83.85 25.89 83.89 25.66 83.89 25.66 83.85 25.89 83.85 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-17",
    points: "83.85 25.89 83.89 25.66 83.89 25.66 83.86 25.89 83.85 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-16",
    points: "83.86 25.89 83.89 25.66 83.89 25.66 83.86 25.89 83.86 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "83.86 25.89 83.89 25.66 83.89 25.66 83.86 25.89 83.86 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "83.86 25.89 83.89 25.66 83.9 25.66 83.86 25.89 83.86 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "83.86 25.89 83.9 25.66 83.9 25.66 83.86 25.89 83.86 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "83.86 25.89 83.9 25.66 83.9 25.66 83.86 25.89 83.86 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "83.86 25.89 83.9 25.66 83.9 25.66 83.86 25.89 83.86 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-11",
    points: "83.86 25.89 83.9 25.66 83.9 25.66 83.86 25.89 83.86 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "83.86 25.89 83.9 25.66 83.9 25.66 83.86 25.89 83.86 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "83.86 25.89 83.9 25.66 83.9 25.67 83.87 25.89 83.86 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "83.87 25.89 83.9 25.67 83.91 25.67 83.87 25.89 83.87 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "83.87 25.89 83.91 25.67 83.91 25.67 83.87 25.89 83.87 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "83.87 25.89 83.91 25.67 83.91 25.67 83.87 25.89 83.87 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "83.87 25.89 83.91 25.67 83.91 25.67 83.87 25.89 83.87 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "83.87 25.89 83.91 25.67 83.91 25.67 83.88 25.9 83.87 25.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "83.88 25.9 83.91 25.67 83.92 25.67 83.88 25.9 83.88 25.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "83.88 25.9 83.92 25.67 83.92 25.67 83.88 25.9 83.88 25.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "83.88 25.9 83.92 25.67 83.92 25.67 83.89 25.9 83.88 25.9"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M84,25.94l0-.23h0L84,26h0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-47",
    points: "83.96 25.95 84 25.72 83.99 25.72 83.95 25.95 83.96 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-44",
    points: "83.95 25.95 83.99 25.72 83.98 25.73 83.95 25.95 83.95 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-43",
    points: "83.95 25.95 83.98 25.73 83.98 25.73 83.94 25.95 83.95 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-42",
    points: "83.94 25.95 83.98 25.73 83.98 25.73 83.94 25.95 83.94 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-41",
    points: "83.94 25.95 83.98 25.73 83.97 25.73 83.93 25.95 83.94 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-40",
    points: "83.93 25.95 83.97 25.73 83.97 25.73 83.93 25.95 83.93 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-39",
    points: "83.93 25.95 83.97 25.73 83.96 25.73 83.92 25.95 83.93 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-38",
    points: "83.92 25.95 83.96 25.73 83.96 25.73 83.92 25.95 83.92 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-37",
    points: "83.92 25.95 83.96 25.73 83.95 25.73 83.92 25.95 83.92 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-36",
    points: "83.92 25.95 83.95 25.73 83.95 25.73 83.91 25.95 83.92 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-35",
    points: "83.91 25.95 83.95 25.73 83.95 25.73 83.91 25.95 83.91 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-34",
    points: "83.91 25.95 83.95 25.73 83.94 25.73 83.9 25.95 83.91 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-33",
    points: "83.9 25.95 83.94 25.73 83.94 25.73 83.9 25.95 83.9 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-32",
    points: "83.9 25.95 83.94 25.73 83.93 25.73 83.9 25.95 83.9 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-31",
    points: "83.9 25.95 83.93 25.73 83.93 25.73 83.89 25.95 83.9 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-30",
    points: "83.89 25.95 83.93 25.73 83.93 25.73 83.89 25.95 83.89 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-29",
    points: "83.89 25.95 83.93 25.73 83.92 25.73 83.89 25.95 83.89 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-28",
    points: "83.89 25.95 83.92 25.73 83.92 25.72 83.89 25.95 83.89 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-27",
    points: "83.89 25.95 83.92 25.72 83.92 25.72 83.88 25.95 83.89 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-26",
    points: "83.88 25.95 83.92 25.72 83.92 25.72 83.88 25.95 83.88 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-25",
    points: "83.88 25.95 83.92 25.72 83.92 25.72 83.88 25.95 83.88 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-24",
    points: "83.88 25.95 83.92 25.72 83.91 25.72 83.88 25.95 83.88 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-23",
    points: "83.88 25.95 83.91 25.72 83.91 25.72 83.87 25.95 83.88 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-22",
    points: "83.87 25.95 83.91 25.72 83.91 25.72 83.87 25.95 83.87 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-21",
    points: "83.87 25.95 83.91 25.72 83.91 25.72 83.87 25.95 83.87 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-20",
    points: "83.87 25.95 83.91 25.72 83.91 25.72 83.87 25.95 83.87 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-19",
    points: "83.87 25.95 83.91 25.72 83.91 25.72 83.87 25.95 83.87 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-18",
    points: "83.87 25.95 83.91 25.72 83.9 25.72 83.87 25.95 83.87 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-17",
    points: "83.87 25.95 83.9 25.72 83.9 25.72 83.86 25.95 83.87 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-16",
    points: "83.86 25.95 83.9 25.72 83.9 25.72 83.86 25.95 83.86 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "83.86 25.95 83.9 25.72 83.9 25.72 83.86 25.95 83.86 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "83.86 25.95 83.9 25.72 83.9 25.72 83.86 25.95 83.86 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "83.86 25.95 83.9 25.72 83.9 25.72 83.86 25.95 83.86 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "83.86 25.95 83.9 25.72 83.9 25.72 83.86 25.95 83.86 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "83.86 25.95 83.9 25.72 83.89 25.72 83.86 25.95 83.86 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-11",
    points: "83.86 25.95 83.89 25.72 83.89 25.72 83.86 25.95 83.86 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "83.86 25.95 83.89 25.72 83.89 25.72 83.86 25.95 83.86 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "83.86 25.95 83.89 25.72 83.89 25.72 83.85 25.95 83.86 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "83.85 25.95 83.89 25.72 83.89 25.72 83.85 25.95 83.85 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "83.85 25.95 83.89 25.72 83.89 25.72 83.85 25.95 83.85 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "83.85 25.95 83.89 25.72 83.89 25.72 83.85 25.95 83.85 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "83.85 25.95 83.89 25.72 83.89 25.72 83.85 25.95 83.85 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "83.85 25.95 83.89 25.72 83.88 25.72 83.84 25.95 83.85 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "83.84 25.95 83.88 25.72 83.88 25.72 83.84 25.95 83.84 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "83.84 25.95 83.88 25.72 83.88 25.72 83.84 25.95 83.84 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "83.84 25.95 83.88 25.72 83.87 25.72 83.87 25.72 83.83 25.94 83.83 25.95 83.84 25.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "83.83 25.94 83.87 25.72 83.87 25.71 83.83 25.94 83.83 25.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "83.83 25.94 83.87 25.71 83.86 25.71 83.83 25.94 83.83 25.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "83.83 25.94 83.86 25.71 83.86 25.71 83.82 25.94 83.83 25.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "83.82 25.94 83.86 25.71 83.86 25.71 83.82 25.94 83.82 25.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "83.82 25.94 83.86 25.71 83.86 25.71 83.82 25.94 83.82 25.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "83.82 25.94 83.86 25.71 83.86 25.71 83.82 25.94 83.82 25.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "83.82 25.94 83.86 25.71 83.86 25.71 83.82 25.94 83.82 25.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "83.82 25.94 83.86 25.71 83.85 25.71 83.82 25.94 83.82 25.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "83.82 25.94 83.85 25.71 83.85 25.71 83.81 25.94 83.82 25.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-11",
    points: "83.81 25.94 83.85 25.71 83.85 25.71 83.81 25.94 83.81 25.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "83.81 25.94 83.85 25.71 83.85 25.71 83.81 25.94 83.81 25.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "83.81 25.94 83.85 25.71 83.85 25.71 83.81 25.94 83.81 25.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "83.81 25.94 83.85 25.71 83.85 25.71 83.81 25.94 83.81 25.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "83.81 25.94 83.85 25.71 83.84 25.71 83.81 25.94 83.81 25.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "83.81 25.94 83.84 25.71 83.84 25.71 83.81 25.94 83.81 25.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-16",
    points: "83.81 25.94 83.84 25.71 83.84 25.71 83.8 25.94 83.81 25.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-17",
    points: "83.8 25.94 83.84 25.71 83.84 25.71 83.8 25.94 83.8 25.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-18",
    points: "83.8 25.94 83.84 25.71 83.84 25.71 83.8 25.94 83.8 25.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-19",
    points: "83.8 25.94 83.84 25.71 83.84 25.71 83.8 25.94 83.8 25.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-20",
    points: "83.8 25.94 83.84 25.71 83.83 25.71 83.8 25.93 83.8 25.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-21",
    points: "83.8 25.93 83.83 25.71 83.83 25.71 83.8 25.93 83.8 25.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-22",
    points: "83.8 25.93 83.83 25.71 83.83 25.7 83.79 25.93 83.8 25.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-23",
    points: "83.79 25.93 83.83 25.7 83.83 25.7 83.79 25.93 83.79 25.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-24",
    points: "83.79 25.93 83.83 25.7 83.82 25.7 83.79 25.93 83.79 25.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-25",
    points: "83.79 25.93 83.82 25.7 83.82 25.7 83.78 25.93 83.79 25.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-26",
    points: "83.78 25.93 83.82 25.7 83.82 25.7 83.78 25.93 83.78 25.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-27",
    points: "83.78 25.93 83.82 25.7 83.81 25.7 83.78 25.93 83.78 25.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-28",
    points: "83.78 25.93 83.81 25.7 83.81 25.7 83.77 25.93 83.78 25.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-29",
    points: "83.77 25.93 83.81 25.7 83.81 25.7 83.77 25.93 83.77 25.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-30",
    points: "83.77 25.93 83.81 25.7 83.8 25.69 83.77 25.92 83.77 25.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-31",
    points: "83.77 25.92 83.8 25.69 83.8 25.69 83.76 25.92 83.77 25.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-32",
    points: "83.76 25.92 83.8 25.69 83.8 25.69 83.76 25.92 83.76 25.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-33",
    points: "83.76 25.92 83.8 25.69 83.8 25.69 83.76 25.92 83.76 25.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-34",
    points: "83.76 25.92 83.8 25.69 83.79 25.69 83.76 25.92 83.76 25.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-35",
    points: "83.76 25.92 83.79 25.69 83.79 25.69 83.75 25.92 83.76 25.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-36",
    points: "83.75 25.92 83.79 25.69 83.79 25.69 83.75 25.91 83.75 25.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-37",
    points: "83.75 25.91 83.79 25.69 83.79 25.68 83.75 25.91 83.75 25.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-38",
    points: "83.75 25.91 83.79 25.68 83.79 25.68 83.75 25.91 83.75 25.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-39",
    points: "83.75 25.91 83.79 25.68 83.79 25.68 83.75 25.91 83.75 25.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-40",
    points: "83.75 25.91 83.79 25.68 83.78 25.68 83.75 25.91 83.75 25.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-41",
    points: "83.75 25.91 83.78 25.68 83.78 25.68 83.75 25.91 83.75 25.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-42",
    points: "83.75 25.91 83.78 25.68 83.78 25.68 83.75 25.91 83.75 25.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-43",
    points: "83.75 25.91 83.78 25.68 83.78 25.68 83.75 25.9 83.75 25.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-44",
    points: "83.75 25.9 83.78 25.68 83.78 25.67 83.75 25.9 83.75 25.9"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "10.55 38.25 0 36.53 74.81 0 85.36 1.72 10.55 38.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "72.73 92.7 62.18 90.99 0 36.53 10.55 38.25 72.73 92.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "72.73 92.7 10.55 38.25 85.36 1.72 72.73 92.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "72.73 92.7 10.55 38.25 85.36 1.72 72.73 92.7"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M84.67,2.62l-12.34,89L11.18,38.57,84.67,2.62m.67-.93L10.22,38.45,72.73,92.7l12.61-91Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset20);
export default __webpack_public_path__ + "static/media/asset20.782ac11bbcff5a92926c9e73e217101d.svg";
export { ForwardRef as ReactComponent };